export type RoleTypeSOS = 'admin' | 'user_new' | 'user_sos' | 'user_trainee';

export const ROLE_LABELS_SOS: {
  [role in RoleTypeSOS]: {
    tag: string;
    label: string;
    color:
      | 'default'
      | 'success'
      | 'primary'
      | 'secondary'
      | 'warning'
      | 'danger';
  };
} = {
  admin: { tag: 'ADMIN', label: 'Admin', color: 'warning' },
  user_new: { tag: 'NEW', label: 'Unassigned', color: 'danger' },
  user_sos: { tag: 'SOS', label: 'SOS', color: 'primary' },
  user_trainee: { tag: 'TRAINEE', label: 'Trainee', color: 'primary' },
};

export type ActorTypeSOS =
  | 'stressed'
  | 'heartbroken'
  | 'body_image'
  | 'traumatised'
  | 'parent'
  | 'abused'
  | 'suicidal_high'
  | 'grieving'
  | 'suicidal_medium'
  | 'grief_SOS'
  | 'friendship_rejection_SOS'
  | 'concerned_son_SOS'
  | 'concerned_girlfriend_SOS'
  | 'non_binary_SOS'
  | 'concerned_friend_SOS'
  | 'harassment_SOS'
  | 'overwork_SOS'
  | 'delusional_SOS'
  | 'borderline_PD_SOS'
  | 'isolation_SOS'
  | 'heartbroken_SOS'
  | 'unemployment_SOS'
  | 'transgender_SOS'
  | 'teacher_SOS';

export const ACTOR_LABELS_SOS: {
  [actor in ActorTypeSOS]: {
    label: string;
  };
} = {
  stressed: { label: 'Anish' },
  heartbroken: { label: 'Claire' },
  body_image: { label: 'Hana' },
  traumatised: { label: 'Jun Jie' },
  parent: { label: 'Karen' },
  abused: { label: 'Sally' },
  suicidal_high: { label: 'Taro' },
  grieving: { label: 'Tom' },
  suicidal_medium: { label: 'Zach' },
  grief_SOS: { label: 'Annabelle' },
  friendship_rejection_SOS: { label: 'Emily' },
  concerned_son_SOS: { label: 'Ethan' },
  concerned_girlfriend_SOS: { label: 'Jasmine' },
  non_binary_SOS: { label: 'Jasper' },
  concerned_friend_SOS: { label: 'Jeremy' },
  harassment_SOS: { label: 'Jessica' },
  overwork_SOS: { label: 'Jovin' },
  delusional_SOS: { label: 'Kai' },
  borderline_PD_SOS: { label: 'Matthias' },
  isolation_SOS: { label: 'May' },
  heartbroken_SOS: { label: 'Nara' },
  unemployment_SOS: { label: 'Rilla' },
  transgender_SOS: { label: 'Taylor' },
  teacher_SOS: { label: 'Winnie' },
};

export const SOS_APP = {
  name: 'AI Care',
  logo: process.env.PUBLIC_URL + '/logo_sos.png',
  about: '/about_sos.md',
  dpp: '/dpp.md',
  tos: '/tos.md',
  disclaimer: 'Please avoid inputting PII data, and report any bugs.',
  clientProfileSections: ['info', 'traffic-light'],
  maskingSupported: true,
  contactPerson: 'buanesvarip@sos.org.sg',
  actors: [
    'grief_SOS',
    'friendship_rejection_SOS',
    'concerned_son_SOS',
    'concerned_girlfriend_SOS',
    'non_binary_SOS',
    'concerned_friend_SOS',
    'harassment_SOS',
    'overwork_SOS',
    'delusional_SOS',
    'borderline_PD_SOS',
    'isolation_SOS',
    'heartbroken_SOS',
    'unemployment_SOS',
    'transgender_SOS',
    'teacher_SOS',
  ],
  assistantName: 'SAM Assistant',
  assistantFunctions: [
    'generate_problem_identification',
    'generate_attempted_solutions',
    'generate_desired_outcome',
    'generate_interventions',
    'generate_C3P_guide',
    'generate_directions',
    'generate_wrap_up',
    'summarize_post',
    'generate_feedback_CT_supervision',
  ],
  featureSettings: [
    {
      key: 'generate_problem_identification',
      label: 'Problem Identification',
      description: `Propose a conversational response only exploring P in PADI`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'generate_attempted_solutions',
      label: 'Attempted Solutions',
      description: `Propose a conversational response only exploring A in PADI`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'generate_desired_outcome',
      label: 'Desired Outcome',
      description: `Propose a conversational response only exploring D in PADI`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'generate_interventions',
      label: 'Interventions',
      description: `Propose a conversational response only exploring I in PADI`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'generate_C3P_guide',
      label: 'C3P Guide',
      description: `Propose a conversational response guiding a concerned third party`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'generate_directions',
      label: 'Propose directions',
      description: `Suggest 3 possible directions with conversational response examples`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: false,
    },
    {
      key: 'generate_wrap_up',
      label: 'Wrap up',
      description: `Propose a conversational response towards wrapping up conversation`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: false,
    },
    {
      key: 'summarize_post',
      label: 'Summarise (Post)',
      description: `Generate post-chat summary (PADI & CPR)`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: false,
    },
    {
      key: 'generate_feedback_CT_supervision',
      label: 'Feedback (CT)',
      description: `Feedback on conversation for CT trainees.`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: false,
    },
  ],
};
